import React, { ReactElement } from 'react'
import { Box } from '@material-ui/core'
import { InfoModel, PermutationModel } from '../services/builder/pageTypes'
import Layout from './Layout'
import Content from './Content'

export interface HelpfileProps {
  pageContext: {
    buildTime: string
    info: InfoModel
    permutation: PermutationModel
  }
}

function Helpfile({ pageContext }: HelpfileProps): ReactElement {
  const { permutation } = pageContext

  return (
    <Layout gameName={permutation.gameName}>
      <Box margin={4} />
      <Content topics={permutation.topics} />
    </Layout>
  )
}

export default Helpfile
